import axios from "axios";
import api from "../../../../services/axios";

export const GetOrganizationMasterData = async () => {
    const res = await api.get("/RecruitmentLead/GetOrganizationData");
    return res.data;
};